import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
    isLoading: false,
    error: null,
    shownotificationclinic: [],
};


const slice = createSlice({
    name: 'shownotificationclinic',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET elementS
        getShowNotificationClinic(state, action) {
            state.isLoading = false;
            state.shownotificationclinic = action.payload;
        },

    },
});
export default slice.reducer;


export function getshownotificationclinic() {
    return async () => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/api/clinic/sendnotifications`);
            dispatch(slice.actions.getShowNotificationClinic(response?.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

